import { deck } from './cliente.js';

export const doCard = (key) => deck({ url: `/issues/${key}/worklogs` });

/** Sempre em MINUTOS. Float de horas volta errado do round-trip (0,1h). */
export const apontar = (key, body) => deck({ method: 'post', url: `/issues/${key}/worklogs`, body });
export const editar = (id, body) => deck({ method: 'put', url: `/worklogs/${id}`, body });
export const apagar = (id) => deck({ method: 'delete', url: `/worklogs/${id}` });

/* Cronometro -- um por pessoa, garantido pelo banco */
export const timer = () => deck({ url: '/timer' });
export const iniciarTimer = (issue_key, note = null) =>
    deck({ method: 'post', url: '/timer/start', body: { issue_key, note } });
export const pararTimer = (body = {}) => deck({ method: 'post', url: '/timer/stop', body });
export const batimentoTimer = () => deck({ method: 'post', url: '/timer/heartbeat' });
export const descartarTimer = () => deck({ method: 'delete', url: '/timer' });

/** A folha da semana (`2026-W39`). A propria sempre; a de outra pessoa, gestor. */
export const folha = (params = {}) => deck({ url: '/timesheet', params });
